export class BulkDetachRestoreTemplateRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceIds",
            "baseName": "resourceIds",
            "type": "Array<string>",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return BulkDetachRestoreTemplateRequest.attributeTypeMap;
    }
    constructor() {
    }
}
